import React from "react";
import i1 from "../../assets/parinday/i1.webp";
import i2 from "../../assets/parinday/i2.webp";

export default function ImageMarquee() {
  return (
    <>
      <div className="hidden  relative lg:flex overflow-x-hidden text-white ">
        <div className="animate-marquee whitespace-nowrap">
          <img src={i1} alt="" className="w-full inline-block" />
        </div>
        <div className="absolute top-0 animate-marquee2 whitespace-nowrap tex-white">
          <img src={i2} alt="" className="w-full inline-block" />
        </div>
      </div>
    </>
  );
}
